import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//保存数据
export const saveData = (params) => {
  return axios.post(root + '/set/usermoduleright/saveData', qs.stringify(params))
}

export const getListByUguid = (params) => {
  return axios.post(root + '/set/usermoduleright/getListByUguid', qs.stringify(params))
}


//判断权限
export const isHaveRight = (params) => {
  return axios.post(root + '/set/usermoduleright/ishaveright', qs.stringify(params))
}


//获取某人的采购权限
export const getexternaldeptbuy = (params) => {
  return axios.post(root + '/set/usermoduleright/getexternaldeptbuy', qs.stringify(params))
}


//
export const uptData = (params) => {
  return axios.post(root + '/set/usermoduleright/uptData', qs.stringify(params))
}


//获取列表
export const listWithUser = (params) => {
  return axios.post(root + '/set/usermoduleright/listwithuser', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/authorityset.js